import { create } from 'zustand';

type DeleteTopicModalStore = {
  isOpen: boolean;
  topicId: string;
  topicName: string;
  openModal: (params: { topicId: string; topicName: string }) => void;
  closeModal: () => void;
};

/**
 * Simple Zustand store for the delete topic modal actions.
 */
export const useDeleteTopicModal = create<DeleteTopicModalStore>((set) => ({
  isOpen: false,
  topicId: '',
  topicName: '',
  openModal: ({ topicId, topicName }) => set({ isOpen: true, topicId, topicName }),
  closeModal: () => set({ isOpen: false, topicId: '', topicName: '' })
}));
